import { useCallback } from "react";
import { useChatApi } from "../../infra/chat-api";
import { useAppSelector } from "../../application/states/hooks";

export const useChatService = () => {
    const { sendMessage, submitEvaluation, getSatisfactionReport } = useChatApi();
    const userState = useAppSelector((state) => state.user);

    const sendChatMessage = useCallback(
        async (data: {
            message: string;
            conversationId?: string;
            context?: {
                currentPage?: string;
                companyId?: string;
                userId?: string;
                userType?: string;
                companyName?: string;
                isResale?: boolean;
            };
        }) => {
            return await sendMessage({
                userId: userState.id,
                message: data.message,
                conversationId: data.conversationId,
                context: data.context,
            });
        },
        [sendMessage, userState.id]
    );

    const submitChatEvaluation = useCallback(
        async (data: {
            rating: number;
            conversationId?: string;
            comment?: string;
        }) => {
            return await submitEvaluation({
                userId: userState.id,
                rating: data.rating,
                conversationId: data.conversationId,
                comment: data.comment,
            });
        },
        [submitEvaluation, userState.id]
    );

    const getChatSatisfactionReport = useCallback(
        async (params: {
            companyId?: string;
            startDate?: string;
            endDate?: string;
        }): Promise<{
            evaluations: Array<{
                id: string;
                companyId: string;
                companyName: string;
                userId: string;
                userName: string;
                conversationId?: string;
                rating: number;
                comment?: string;
                createdAt: string;
            }>;
        }> => {
            return await getSatisfactionReport({
                userId: userState.id,
                companyId: params.companyId || "",
                startDate: params.startDate,
                endDate: params.endDate,
            });
        },
        [getSatisfactionReport, userState.id]
    );

    return {
        sendChatMessage,
        submitChatEvaluation,
        getChatSatisfactionReport,
    };
};
